import { TrueType } from 'library/ts/utilities/modules/enums/TrueType';
import * as NumberModule from 'library/ts/utilities/modules/Number';
export const generateUUID = (pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx') => {
    let d = new Date().getTime();
    return pattern.replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
};
export const playerServicesUUID = () => {
    return (random(NumberModule.random(3, 3), alphabet().toLowerCase()) +
        '-' +
        generateUUID(random(NumberModule.random(3, 3)) +
            '-' +
            random(NumberModule.random(3, 3))));
};
export const random = (length = 10, chars = 'xy') => {
    let output = '';
    while (length--)
        output += chars[Math.floor(Math.random() * chars.length)];
    return output;
};
export const shuffle = (str = '') => {
    return [...str].sort(() => Math.random() - .5).join('');
};
export const alphabet = () => {
    const alphabet = [];
    const start = ('A').charCodeAt(0);
    const last = ('Z').charCodeAt(0);
    for (let i = start; i <= last; ++i) {
        alphabet.push(String.fromCharCode(i));
    }
    return alphabet.join('');
};
export const trim = (x) => {
    return x.replace(/^\s+|\s+$/gm, '');
};
export const hasSubstring = (sourceString, substring) => {
    if (typeof substring === TrueType.STRING)
        substring = [substring];
    if (substring instanceof Array) {
        for (let i = 0; i < substring.length; i++) {
            if (sourceString.indexOf(substring[i]) !== -1) {
                return true;
            }
        }
    }
    return false;
};
export const startPad = (str = '', paddingChar = '0', totalWidth = 1) => {
    if (str.length >= totalWidth)
        return str;
    const array = new Array(totalWidth);
    for (let i = 0; i < array.length; i++) {
        array[i] = paddingChar;
    }
    return (array.join('') + str).slice(-array.length);
};
export const cleanUp = (str, carriageReturn = true, tab = true, whitespaceBeforeTags = true, whitespaceBetweenTags = true, whitespaceAfterTags = true) => {
    if (carriageReturn === true)
        str = str.replace(/\n/g, '');
    if (tab === true)
        str = str.replace(/\t/g, '');
    if (whitespaceBeforeTags === true)
        str = str.replace(/[\t ]+\</g, '<');
    if (whitespaceBetweenTags === true)
        str = str.replace(/\>[\t ]+\</g, '><');
    if (whitespaceAfterTags === true)
        str = str.replace(/\>[\t ]+$/g, '>');
    return str;
};
export const timeFormatter = (pSeconds) => {
    if (pSeconds < 0 || isNaN(pSeconds))
        return '00:00';
    const tmpTime = Math.round(pSeconds);
    let secondsOUT;
    let minutesOUT;
    let hoursOUT;
    let seconds = tmpTime;
    let minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    minutes = minutes % 60;
    seconds = seconds % 60;
    hoursOUT = String(hours);
    minutesOUT = String(minutes);
    secondsOUT = String(seconds);
    if (hours < 10) {
        hoursOUT = '0' + hours;
    }
    if (minutes < 10) {
        minutesOUT = '0' + minutes;
    }
    if (seconds < 10) {
        secondsOUT = '0' + seconds;
    }
    if (hours !== 0) {
        return hoursOUT + ':' + minutesOUT + ':' + secondsOUT;
    }
    else {
        return minutesOUT + ':' + secondsOUT;
    }
};
export const escapeHTML = (string) => {
    const entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        '\'': '&#39;',
        '/': '&#x2F;'
    };
    return String(string).replace(/[&<>"'\/]/g, (s) => {
        return entityMap[s];
    });
};
export const replace = (string = '', pattern, newValue = '', regexFlags = '') => {
    RegExp['escape'] = (string) => {
        return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    };
    const regex = new RegExp(RegExp['escape'](pattern), regexFlags);
    return string.replace(regex, newValue);
};
export const compareVersion = (version1, version2) => {
    const v1 = version1.split('.').map(Number);
    const v2 = version2.split('.').map(Number);
    const k = Math.min(v1.length, v2.length);
    for (let i = 0; i < k; ++i) {
        if (v1[i] > v2[i])
            return 1;
        if (v1[i] < v2[i])
            return -1;
    }
    return v1.length == v2.length ? 0 : (v1.length < v2.length ? -1 : 1);
};
